/* Etern Homme · Portada */
(function () {
  if (window.EH_HOME) return;
  window.EH_HOME = true;

  var money = function (cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  };

  /* ---------- Añadir a la cesta (usa la cesta lateral de Dawn si existe) ---------- */
  function addToCart(variantId, btn) {
    if (!variantId) return;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    if (btn) btn.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { alert(res.description || res.message || 'No se ha podido añadir a la cesta.'); return; }
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () { window.location.href = root + 'cart'; })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-eh-add]');
    if (!b) return;
    e.preventDefault();
    if (b.hasAttribute('data-eh-close-quiz')) quiz.close();
    addToCart(b.getAttribute('data-variant'), b);
  });

  /* ---------- Kits por duración + tabla + barra fija ---------- */
  var tierApi = null;
  function initTiers(root) {
    var tiers = [].slice.call(root.querySelectorAll('.tier')), add = root.querySelector('[data-tier-add]');
    if (!tiers.length || !add) return;
    var cols = root.querySelectorAll('.matrix [data-col]');
    var bar = root.querySelector('.eh-sticky'), chips = bar ? bar.querySelectorAll('.chip') : [];
    function pick(t) {
      var idx = tiers.indexOf(t);
      tiers.forEach(function (x) { x.setAttribute('aria-checked', x === t ? 'true' : 'false'); x.tabIndex = x === t ? 0 : -1; });
      add.setAttribute('data-variant', t.getAttribute('data-variant'));
      add.textContent = add.getAttribute('data-label').replace('[kit]', t.getAttribute('data-title'));
      cols.forEach(function (c) { c.classList.toggle('on', +c.getAttribute('data-col') === idx); });
      if (bar) {
        bar.querySelector('.name b').textContent = t.getAttribute('data-title');
        bar.querySelector('.name small').textContent = t.getAttribute('data-dur') || '';
        bar.querySelector('.price').textContent = t.getAttribute('data-price');
        var im = bar.querySelector('img'); if (im && t.getAttribute('data-img')) im.src = t.getAttribute('data-img');
        bar.querySelector('[data-eh-add]').setAttribute('data-variant', t.getAttribute('data-variant'));
        chips.forEach(function (c, i) { c.setAttribute('aria-pressed', i === idx ? 'true' : 'false'); });
      }
    }
    tiers.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(t); return; }
        var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var nx = tiers[(i + d + tiers.length) % tiers.length]; pick(nx); nx.focus();
      });
    });
    chips.forEach(function (c, i) { c.addEventListener('click', function () { pick(tiers[i]); }); });
    pick(root.querySelector('.tier[aria-checked="true"]') || tiers[0]);

    /* La barra aparece cuando has pasado la sección de kits y se esconde al llegar al pie */
    if (bar && 'IntersectionObserver' in window) {
      var past = false, nearEnd = false;
      var upd = function () { bar.classList.toggle('on', past && !nearEnd); bar.setAttribute('aria-hidden', past && !nearEnd ? 'false' : 'true'); };
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { past = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); });
      }).observe(root.querySelector('.buy'));
      var foot = document.querySelector('footer, .footer, #shopify-section-footer, [id*="footer"]');
      if (foot) new IntersectionObserver(function (es) { es.forEach(function (e) { nearEnd = e.isIntersecting; upd(); }); }).observe(foot);
    }
    tierApi = {
      pick: function (handle) {
        var t = tiers.filter(function (x) { return x.getAttribute('data-handle') === handle; })[0];
        if (t) pick(t);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
  }
  document.addEventListener('click', function (e) {
    var k = e.target.closest('[data-eh-pick]');
    if (!k || !tierApi) return;
    e.preventDefault();
    tierApi.pick(k.getAttribute('data-eh-pick'));
  });

  /* ---------- Carrusel ---------- */
  function initRail(root) {
    var rail = root.querySelector('.rail'), prog = root.querySelector('.progress i'), prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (!rail) return;
    function state() {
      var max = rail.scrollWidth - rail.clientWidth, r = max > 0 ? rail.scrollLeft / max : 0, w = rail.clientWidth / rail.scrollWidth;
      if (prog) { prog.style.width = (w * 100) + '%'; prog.style.left = (r * (1 - w) * 100) + '%'; }
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft > max - 4;
    }
    var step = function () { var c = rail.querySelector('.card'); return c ? c.offsetWidth + 14 : 300; };
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() }); });
    rail.addEventListener('scroll', state, { passive: true });
    window.addEventListener('resize', state);
    state();
  }

  /* ---------- Ritual con imagen fija ---------- */
  function initRitual(root) {
    var steps = root.querySelectorAll('.step'), vis = root.querySelectorAll('.visual img'), count = root.querySelector('.count');
    if (!steps.length) return;
    function set(n) {
      steps.forEach(function (s, i) { s.classList.toggle('on', i === n); });
      vis.forEach(function (v, i) { v.classList.toggle('on', i === n); });
      if (count) count.textContent = (n + 1) + ' / ' + steps.length;
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) set([].indexOf.call(steps, e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    }
    set(0);
  }

  /* ---------- Kit con puntos ---------- */
  function initKit(root) {
    var dots = root.querySelectorAll('.dot'), pieces = root.querySelectorAll('.pieces li');
    function hi(n) {
      dots.forEach(function (d, i) { d.classList.toggle('on', i === n); });
      pieces.forEach(function (p, i) { p.classList.toggle('on', i === n); });
    }
    dots.forEach(function (d, i) {
      ['mouseenter', 'focus', 'click'].forEach(function (ev) { d.addEventListener(ev, function () { hi(i); }); });
      d.addEventListener('mouseleave', function () { hi(-1); });
    });
    pieces.forEach(function (p, i) {
      p.addEventListener('mouseenter', function () { hi(i); });
      p.addEventListener('mouseleave', function () { hi(-1); });
    });
  }

  /* ---------- Test de 1 minuto ---------- */
  var quiz = (function () {
    var el, body, bar, data, answers = [], lastFocus;
    var Q = [
      { q: '¿Qué quieres mejorar?', o: [['barba', 'La barba'], ['cabello', 'El cabello'], ['ambos', 'Las dos cosas']] },
      { q: '¿Cómo lo describirías?', o: [['huecos', 'Tengo zonas despobladas', 'Mejillas, bigote o entradas'], ['fino', 'Crece, pero fino y sin volumen'], ['seco', 'Seco, áspero o con picor']] },
      { q: '¿Has usado un roller antes?', o: [['no', 'Nunca'], ['si', 'Sí, alguna vez']] }
    ];
    function bind() {
      el = document.querySelector('.eh-quiz');
      if (!el) return false;
      body = el.querySelector('.body'); bar = el.querySelector('.bar i');
      try { data = JSON.parse(el.querySelector('script[type="application/json"]').textContent); } catch (e) { data = {}; }
      return true;
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function draw() {
      var i = answers.length;
      bar.style.width = (i / Q.length * 100) + '%';
      if (i === Q.length) return result();
      var h = '<div class="q"><small>Pregunta ' + (i + 1) + ' de ' + Q.length + '</small><h2 class="wide">' + Q[i].q + '</h2><div class="opts">';
      Q[i].o.forEach(function (o) { h += '<button type="button" class="opt" data-a="' + o[0] + '">' + o[1] + (o[2] ? '<span>' + o[2] + '</span>' : '') + '</button>'; });
      h += '</div>' + (i ? '<button type="button" class="back ulink" data-back>Volver</button>' : '') + '</div>';
      body.innerHTML = h;
      var f = body.querySelector('.opt'); if (f) f.focus();
    }
    function pickKey() {
      var goal = answers[0], zone = answers[1], used = answers[2];
      if (goal === 'ambos') return ['kit', 'reason_both'];
      if (zone === 'seco') return ['kit', 'reason_dry'];
      if (zone === 'huecos') return ['pack', 'reason_gaps'];
      if (used === 'no') return ['starter', 'reason_new'];
      return ['pack', 'reason_default'];
    }
    function result() {
      var k = pickKey(), p = (data.products || {})[k[0]];
      if (!p) { body.innerHTML = '<div class="q"><h2 class="wide">Elige un producto en la sección del test.</h2></div>'; return; }
      body.innerHTML = '<div class="q res"><div class="res-img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') + '</div><div><small>Tu recomendación</small><h2 class="wide">' + esc(p.title) + '</h2><div class="price">' + money(p.price) + '</div><p>' + esc(data[k[1]] || '') + '</p>' +
        '<div class="res-ctas"><button type="button" class="btn btn-dark" data-eh-add data-eh-close-quiz data-variant="' + p.variant + '">Añadir a la cesta</button><a class="ulink" href="' + esc(p.url) + '">Ver el producto</a><button type="button" class="ulink" data-restart>Repetir el test</button></div></div></div>';
    }
    function open() {
      if (!el && !bind()) return;
      lastFocus = document.activeElement;
      answers = []; draw();
      el.classList.add('on'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('eh-lock');
    }
    function close() {
      if (!el) return;
      el.classList.remove('on'); el.setAttribute('aria-hidden', 'true'); document.body.classList.remove('eh-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-eh-quiz]')) { e.preventDefault(); open(); return; }
      if (!el || !el.contains(e.target)) return;
      var o = e.target.closest('.opt'); if (o) { answers.push(o.getAttribute('data-a')); draw(); }
      if (e.target.closest('[data-back]')) { answers.pop(); draw(); }
      if (e.target.closest('[data-restart]')) { answers = []; draw(); }
      if (e.target.closest('.close')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el && el.classList.contains('on')) close(); });
    return { open: open, close: close, rebind: function () { el = null; }, _set: function (a) { answers = a; draw(); } };
  })();
  window.EH_QUIZ = quiz;

  /* ---------- Arranque ---------- */
  var inits = { tiers: initTiers, rail: initRail, ritual: initRitual, kit: initKit };
  function boot(scope) {
    (scope || document).querySelectorAll('[data-eh]').forEach(function (n) {
      var f = inits[n.getAttribute('data-eh')];
      if (f && !n.__eh) { n.__eh = true; f(n); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { quiz.rebind(); boot(e.target); });
})();
